var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lab-header"},[_vm._m(0),(_vm.date)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.$t("lab.resultsDate")))]),_c('div',[_vm._v(_vm._s(_vm.date))])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div'),_c('div')])
}]

export { render, staticRenderFns }